<template>
  <div class="w-full flex-1-0-auto header-height-top-space viewport-gutter pt-4 pb-16 xl:pb-32 lufthansa-text">
    <div class="container">
      <div v-if="hideBreadcrumb" class="pb-10 xl:pb-20 leading-none text-sm opacity-0">
        &nbsp;
      </div>
      <breadcrumb
        v-else
        :title="tr(`pages.${pageType}.title`)"
        class="pb-10 xl:pb-20"
      />

      <h1 id="main-content" class="text-3xl font-bold leading-tight pb-6 xl:text-4xl xl:pb-10">
        {{ tr(`pages.${pageType}.title`) }}
      </h1>

      <div class="w-full max-w-212 text-sm xl:text-lg">
        <div
          v-for="(item, index) in items"
          :key="index"
          :class="{'pb-4 xl:pb-8': index < (items.length - 1) }"
        >
          <h2
            v-if="item.title"
            class="text-2.5xl pb-4 xl:text-3xl"
          >
            {{ item.title }}
          </h2>
          <div
            v-for="(description, descriptionIndex) in item.descriptions"
            :key="descriptionIndex"
            class="pb-6"
            v-html="description"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '~brand-components/lufthansa/shared/breadcrumb.vue'
import TextSubpage from '~components/shared/text-subpage'

export default TextSubpage.extend({
  components: {
    Breadcrumb,
  },
})
</script>

<style lang="scss" scoped>
.lufthansa-text::v-deep {
  h3 {
    @apply font-bold;

    margin-bottom: 14px;
  }

  a {
    @apply font-bold text-navy-700;

    &:hover {
      @apply underline;
    }
  }
}
</style>
